import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import filterNumbers from 'notebook/tables/excess/util/filterNumbers';
import sum from 'notebook/tables/excess/util/sum';

export default {
  name: 'SUM',
  shortDescription: 'Sum of a series of numbers and/or cells.',
  category: FunctionCategory.MATH,
  description: 'Returns the sum of a series of numbers and/or cells.',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'The first number or range to add together.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'Additional numbers or ranges to add to value1.',

  eval: (...values): number => {
    const numberValues = filterNumbers(values);
    return sum(numberValues);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
